module.exports = __webpack_public_path__ + "img/MESTNA OBCINA NOVA GORICA.d72b8e88.png";